const ActivityStatusEnum = {
  active: 'ACTIVE',
  deleted: 'DELETED'
};

export { ActivityStatusEnum };
export default ActivityStatusEnum;
